/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type UseManagePlaylistForm_CustomerFragment = { __typename: 'Customer', id: string, playlists: Array<{ __typename: 'Playlist', id: string, title: string, size: any, playlistType: Types.PlaylistType }> };

export type BulkUpdatePlaylistMutationVariables = Types.Exact<{
  input: Types.DisplayBulkUpdatePlaylistInput;
}>;


export type BulkUpdatePlaylistMutation = { __typename: 'Mutation', displayBulkUpdatePlaylist: { __typename: 'DisplayBulkUpdatePlaylistPayload', displays: Array<{ __typename: 'Display', id: string, playlist?: { __typename: 'DisplayPlaylist', current?: { __typename: 'DisplayCurrentPlaylist', id: string, title: string } | null } | null }> } };

export const UseManagePlaylistForm_CustomerFragmentDoc = gql`
    fragment useManagePlaylistForm_customer on Customer {
  id
  playlists {
    id
    title
    size
    playlistType
  }
}
    `;
export const BulkUpdatePlaylistDocument = gql`
    mutation BulkUpdatePlaylist($input: DisplayBulkUpdatePlaylistInput!) {
  displayBulkUpdatePlaylist(input: $input) {
    displays {
      id
      playlist {
        current {
          id
          title
        }
      }
    }
  }
}
    `;
export type BulkUpdatePlaylistMutationFn = ApolloReactCommon.MutationFunction<BulkUpdatePlaylistMutation, BulkUpdatePlaylistMutationVariables>;

/**
 * __useBulkUpdatePlaylistMutation__
 *
 * To run a mutation, you first call `useBulkUpdatePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdatePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdatePlaylistMutation, { data, loading, error }] = useBulkUpdatePlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdatePlaylistMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUpdatePlaylistMutation, BulkUpdatePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUpdatePlaylistMutation, BulkUpdatePlaylistMutationVariables>(BulkUpdatePlaylistDocument, options);
      }
export type BulkUpdatePlaylistMutationHookResult = ReturnType<typeof useBulkUpdatePlaylistMutation>;
export type BulkUpdatePlaylistMutationResult = ApolloReactCommon.MutationResult<BulkUpdatePlaylistMutation>;
export type BulkUpdatePlaylistMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUpdatePlaylistMutation, BulkUpdatePlaylistMutationVariables>;